<div class="admin-site-based-admins ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

  <div class="col-md-10 offset-md-1" [hidden]="isLoading">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <span [innerHTML]="'tkey;admin.site_based_admins.description' | escapeHtml"></span>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    <ziro-datatable
      [class]="'ziro-card'"
      [columns]="columns"
      [rowDataSource]="rows"
      [uniqueRowIdentifier]="'userId'"
      [dataAutomation]="tableAutomationId"
      [showSelectColumn]="true"
      [resetPageOnDataChange]="false"
      [setColumnWidths]="true"
      (rowSelected)="onRowSelected()"
    >
      <ziro-datatable-multi-select-filter
        [label]="'tkey;admin.sitemacman.authorizedSitesHeader'"
        [items]="authorizedSitesFilterOptions"
        [matchFn]="isAuthorizedSitesMatch.bind(this)"
        [dataAutomation]="'authorized-site-cluster-filter'"
        [tableId]="tableAutomationId"
      ></ziro-datatable-multi-select-filter>
      <ziro-datatable-multi-select-filter
        [label]="'tkey;admin.sitemacman.control.header'"
        [items]="['Enabled', 'Disabled']"
        [matchFn]="isControlMatch"
        [dataAutomation]="'control-filter'"
        [tableId]="tableAutomationId"
      ></ziro-datatable-multi-select-filter>
    </ziro-datatable>
  </div>
</div>

<ziro-bottom-nav [hidden]="!isUpdateDisplayed"></ziro-bottom-nav>
